import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAccommodation($companyId: ID!, $attributes: AccommodationAttributes!) {
    createAccommodation(companyId: $companyId, attributes: $attributes) {
       accommodation {
        id
        ...CreatedAccommodation
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAccommodation on Accommodation {
    id
    name
    address
  }
`
